import { useCallback, useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'
import { ContentStackTypes, FeatureFlagKeys } from '../store/Constants'

export const useExternalLink = () => {
  const { cachedCMS, flags } = useContext(ConfigContext)

  const findExternalLink = useCallback(
    (linkTitle) => {
      const normalizedLinkTitle = linkTitle?.toUpperCase()

      if (
        normalizedLinkTitle === 'HP_SMART_WINDOWS' &&
        flags?.[FeatureFlagKeys.olexPswHpxOffer] === true
      ) {
        const hpxLink = cachedCMS
          ?.get(ContentStackTypes.external_links.content_type_uid)
          ?.all_links.find(
            (externalLink) =>
              externalLink?.link?.title?.toUpperCase() === 'HPX_WINDOWS'
          )
        if (hpxLink) {
          return hpxLink
        }
      }
      return cachedCMS
        ?.get(ContentStackTypes.external_links.content_type_uid)
        ?.all_links.find(
          (externalLink) =>
            externalLink?.link?.title?.toUpperCase() === normalizedLinkTitle
        )
    },
    [cachedCMS, flags]
  )

  const findExternalLinkByLink = (linkHref) => {
    return cachedCMS
      .get(ContentStackTypes.external_links.content_type_uid)
      .all_links.find(
        (externalLink) =>
          externalLink.link.href.toUpperCase() === linkHref.toUpperCase()
      )
  }

  const replaceStringByExternalLink = (content, param, link) => {
    return content.replace(`[[EXTERNAL_LINKS(${param})]]`, link)
  }

  const getExternalLinkParameter = (cmsLink) => {
    if (
      cmsLink.indexOf('[[EXTERNAL_LINKS(') === -1 ||
      cmsLink.indexOf(')]]') === -1
    ) {
      return null
    }
    return cmsLink.split('[[EXTERNAL_LINKS(')[1].split(')]]')[0]
  }

  const replaceContentWithExternalLink = (content) => {
    if (!content.startsWith('[[HAVE_EXTERNAL_LINK]]')) {
      return content
    }
    let parameter = getExternalLinkParameter(content)
    let finalContent = content.replace('[[HAVE_EXTERNAL_LINK]]', '')
    while (parameter) {
      const link = findExternalLink(parameter)
      finalContent = replaceStringByExternalLink(
        finalContent,
        parameter,
        link?.link?.href || '#'
      )
      parameter = getExternalLinkParameter(finalContent)
    }
    return finalContent
  }

  return {
    findExternalLink,
    findExternalLinkByLink,
    replaceContentWithExternalLink
  }
}
